/* Component Dependencies */
var propertyFeatureOverviewTemplate = require('templates/propertyFeatureOverview.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'propertyFeatureOverview',
  template: {
    'propertyFeatureOverview': propertyFeatureOverviewTemplate
  }
});
